import $ from 'jquery'
import 'sharer.js'

$('.part-share__opener').on('click', function () {
  $(this).parent().toggleClass('part-share--active')
})

$(document).on('click', function (e) {
  if ($(e.target).closest('.part-share').length === 0) {
    $('.part-share').removeClass('part-share--active')
  }
})

let copyWaiting = false
$('.part-share__copy').on('click', function () {
  navigator.clipboard.writeText($(this).attr('data-url'))

  if (!copyWaiting) {
    $(this).find('i').toggleClass('vn-icons-attach vn-icons-tick')
    copyWaiting = true

    setTimeout(() => {
      $(this).find('i').toggleClass('vn-icons-tick vn-icons-attach')
      copyWaiting = false
    }, 2000)
  }
})
